'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarWarning;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function CalendarWarning(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-calendar-warning', className),
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M7.1125,6.33593751 C7.1125,6.24635411 7.1416666,6.16796876 7.2,6.10078125 C7.2583334,6.03359375 7.3291666,6 7.4125,6 L8.5875,6 C8.6708334,6 8.7416666,6.03359375 8.8,6.10078125 C8.8583334,6.16796876 8.8875,6.24635411 8.8875,6.33593751 L8.7125,9.99093768 C8.7125,10.0805211 8.6833334,10.1544273 8.625,10.2126564 C8.5666666,10.2708855 8.4958334,10.3000002 8.4125,10.3000002 L7.5875,10.3000002 C7.5041666,10.3000002 7.4333334,10.2708855 7.375,10.2126564 C7.3166666,10.1544273 7.2875,10.0805211 7.2875,9.99093768 L7.1125,6.33593751 Z' }),
      _react2.default.createElement('circle', { cx: '8', cy: '12', r: '1' }),
      _react2.default.createElement('rect', { stroke: color, width: '12.5', height: '12.5', x: '1.75', y: '2.75', strokeWidth: '1.5', rx: '1.5' }),
      _react2.default.createElement('path', { fill: color, d: 'M5.69999999,3 L10.3,3 C10.1343146,3 10,2.86568542 10,2.69999999 L10,0.300000012 C10,0.13431458 10.1343146,-2.50752312e-17 10.3,-5.55111512e-17 L11.7,0 C11.8656854,-3.043592e-17 12,0.13431458 12,0.300000012 L12,2.69999999 C12,2.86568542 11.8656854,3 11.7,3 L14,3 L14,5 L2,5 L2,3 L4.30000001,3 C4.13431458,3 4,2.86568542 4,2.69999999 L4,0.300000012 C4,0.13431458 4.13431458,-2.50752312e-17 4.30000001,-5.55111512e-17 L5.69999999,0 C5.86568542,-3.043592e-17 6,0.13431458 6,0.300000012 L6,2.69999999 C6,2.86568542 5.86568542,3 5.69999999,3 Z' })
    )
  );
}

CalendarWarning.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/CalendarWarning/CalendarWarning.js
// module id = 137
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14